module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"index":"点击进入公司网址","document-title":"了解金姆脉诊仪"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
